// Profile API service for cross-device sync

const API_URL = process.env.REACT_APP_BACKEND_URL;

if (!API_URL) {
  console.error('REACT_APP_BACKEND_URL environment variable is required');
}

export const profilesApi = {
  // Get all profiles for a user (including team profiles)
  async getProfiles(userId, includeTeam = true) {
    try {
      const response = await fetch(`${API_URL}/api/profiles/${userId}?include_team=${includeTeam}`);
      if (!response.ok) {
        throw new Error('Failed to fetch profiles');
      }
      return await response.json();
    } catch (error) {
      console.error('Error fetching profiles:', error);
      return [];
    }
  },

  // Create a new profile
  async createProfile(profile) {
    try {
      const response = await fetch(`${API_URL}/api/profiles`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          user_id: profile.userId,
          team_id: profile.teamId || null,
          name: profile.name,
          type: profile.type || 'business',
          website: profile.website || null,
          description: profile.description,
          platforms: profile.platforms || [],
          instructions: profile.instructions || null,
          logo: profile.logo || null,
          news_topics: profile.newsTopics || [],
          use_trending_news: profile.useTrendingNews || false,
          generation_days: profile.generationDays || 7,
          posts_per_day: profile.postsPerDay || 1,
        }),
      });
      
      if (!response.ok) {
        throw new Error('Failed to create profile');
      }
      return await response.json();
    } catch (error) {
      console.error('Error creating profile:', error);
      throw error;
    }
  },

  // Update an existing profile
  async updateProfile(profileId, profile) {
    try {
      const response = await fetch(`${API_URL}/api/profiles/${profileId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: profile.name,
          type: profile.type,
          website: profile.website || null,
          description: profile.description,
          platforms: profile.platforms,
          instructions: profile.instructions || null,
          logo: profile.logo || null,
          news_topics: profile.newsTopics || [],
          use_trending_news: profile.useTrendingNews || false,
          generation_days: profile.generationDays || 7,
          posts_per_day: profile.postsPerDay || 1,
          team_id: profile.teamId || null,
        }),
      });
      
      if (!response.ok) {
        throw new Error('Failed to update profile');
      }
      return await response.json();
    } catch (error) {
      console.error('Error updating profile:', error);
      throw error;
    }
  },

  // Delete a profile
  async deleteProfile(profileId) {
    try {
      const response = await fetch(`${API_URL}/api/profiles/${profileId}`, {
        method: 'DELETE',
      });
      
      if (!response.ok) {
        throw new Error('Failed to delete profile');
      }
      return true;
    } catch (error) {
      console.error('Error deleting profile:', error);
      throw error;
    }
  },

  // Convert API profile to frontend format
  toFrontendFormat(apiProfile) {
    return {
      id: apiProfile.id,
      userId: apiProfile.user_id,
      teamId: apiProfile.team_id,
      name: apiProfile.name,
      type: apiProfile.type,
      website: apiProfile.website,
      description: apiProfile.description,
      platforms: apiProfile.platforms,
      instructions: apiProfile.instructions,
      logo: apiProfile.logo,
      newsTopics: apiProfile.news_topics,
      useTrendingNews: apiProfile.use_trending_news,
      generationDays: apiProfile.generation_days,
      postsPerDay: apiProfile.posts_per_day,
      isTeamProfile: !!apiProfile.team_id,
    };
  },
};
